import SelectRosterTabs from "../components/SelectRosterTabs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { MULTI_CLASS_SELECT_LEARNERS_KEY } from "../../constants";

const SelectRoster = () => {
  const location = useLocation();

  useEffect(() => {
    const learners = location?.state?.multiClassSelectLearners;
    if (!Array.isArray(learners)) return;
    try {
      sessionStorage.setItem(MULTI_CLASS_SELECT_LEARNERS_KEY, JSON.stringify(learners));
    } catch (e) {
      console.error(e);
    }
  }, [location?.state]);

  return (
    <div className="container">
      <SelectRosterTabs />
    </div>
  );
};

export default SelectRoster;
